import { Route } from 'react-router-dom'
import { Navigate, Routes } from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css'
import Home from './components/Home';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-modern-drawer/dist/index.css'
import './app.scss';
import Checkout from './components/Checkout';
import DetallesOrden from './components/DetallesOrden';
import Business from './components/chocolateandino/business';
import Origin from './components/chocolateandino/origin';
import Contacto from './components/chocolateandino/contact';

const AppRouter = () => {
        return <Routes>
          <Route  path="/" element={<Home/>} />
          <Route  path="/checkout" element={<Checkout />} />
          <Route  path="/business" element={<Business />} />
          <Route  path="/nosotros" element={<Origin />} />
          <Route  path="/contacto" element={<Contacto />} />
          <Route  path="/order-details/:id" element={<DetallesOrden />} />
          <Route path='*' element={<Navigate to="/" />} />
      </Routes>   
}

export default AppRouter